const footerText = [
  {
    copy: "All rights reserved.",
  },
  {
    copy: "Visos teisės saugomos.",
  },
  {
    copy: "Wszystkie prawa zastrzeżone.",
  },
];

export default footerText;
